export default __webpack_public_path__ + "static/media/planets.0cf30dbf.png";